













import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { getOrgInfo } from '@/api/school.ts';
const namespace = 'user';
@Component({})
export default class Detail extends Vue {
  @State('orgId', { namespace }) orgId!: string;
  @State('id', { namespace }) id!: string;
  activeName = 'detail';
  isOrg = false;
  activated() {
    this.handleNav();
    this.getOrgInfo();
  }
  handleNav() {
    let arr = this.$route.path.split('/'),
      path = arr[arr.length - 1];
    this.activeName = path;
  }
  handleTabClick(tab: any) {
    const id = this.$route.params.id;
    this.$router.push(`/school/manage/${tab.name}`);
  }
  async getOrgInfo() {
    try {
      let res = await getOrgInfo({
        orgId: this.orgId,
        accountId: this.id
      });
      this.isOrg = res.orgInfo.cuStomerType === 1 ? true : false
    } catch (error) {
      this.$message.error(error.message)
    }
  }
}
